import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	starredLabel: {
		id: 'navigation.global-side-navigation.starred.label',
		description:
			'Label on Starred button in the side navigation. Shows a flyout with starred items.',
		defaultMessage: 'Starred',
	},
});
